import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBS = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M15.218 16.304h33.228C44.913 6.784 35.75 0 25 0A24.918 24.918 0 0 0 7.324 7.323l7.894 8.981ZM15.218 33.696h33.228C44.913 43.216 35.75 50 25 50a24.918 24.918 0 0 1-17.677-7.323l7.894-8.981Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M7.322 7.321c-9.763 9.763-9.763 25.592 0 35.355L25 25 7.322 7.32Z"
}));
FlagBS.displayName = 'FlagBS';
export default withFlagWrapper(FlagBS);
//# sourceMappingURL=index.js.map